module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpoti_m2.88c94ec1ad19511ef3d7f08f288438f1.png";